import RestApiModel from "@/api/Model/RestApiModel";

class Submissions extends RestApiModel {
  static getResourceEndpoint() {
    return '/OrderSubmission';
  }
}

export default Submissions;
